import { createSlice } from "@reduxjs/toolkit";
import isEmpty from "lodash/isEmpty";

const spinner = createSlice({
  name: "spinner",
  initialState: { showSpinner: false, currentlyLoading: {}, anythingLoading: false },
  reducers: {
    showSpinner(state, action) {
      state.showSpinner = true;
      if (!isEmpty(action.payload)) {
        state.currentlyLoading[action.payload] = true;
        state.anythingLoading = !isEmpty(state.currentlyLoading);
      }
    },
    hideSpinner(state, action) {
      state.showSpinner = false;
      if (!isEmpty(action.payload)) {
        delete state.currentlyLoading[action.payload];
        state.anythingLoading = !isEmpty(state.currentlyLoading);
      }
    },
  },
});

export const { showSpinner, hideSpinner } = spinner.actions;
export default spinner.reducer;
